import { ref } from 'vue';
import { defineStore } from 'pinia';
import {
  Filters,
  DEFAULT_FILTERS,
  BOOLEAN_FIELDS,
  DATE_FIELDS,
} from '@/entities/Document/@x/Filter';
import { deserializeDates, deserializeBooleans } from '@/shared/lib/utils';

export default defineStore('filters', () => {
  const loadFiltersFromStorage = (): Filters => {
    try {
      const loadedState = localStorage.getItem('Filters');
      if (loadedState) {
        const parsed = JSON.parse(loadedState);
        const withDates = deserializeDates<Filters>(parsed, DATE_FIELDS);
        const withBooleans = deserializeBooleans<Filters>(withDates, BOOLEAN_FIELDS);

        return { ...DEFAULT_FILTERS, ...withBooleans };
      }
    } catch (err) {
      console.error('Erro ao carregar filtros do localStorage:', err);
    }
    return { ...DEFAULT_FILTERS };
  };

  const filters = ref<Filters>(loadFiltersFromStorage());

  function setFilters(newFilters: Partial<Filters>) {
    const mergedFilters: Filters = { ...DEFAULT_FILTERS };

    (Object.keys(newFilters) as Array<keyof Filters>).forEach(<K extends keyof Filters>(key: K) => {
      const value = newFilters[key];
      if (value === null || value === undefined || value === '') {
        return;
      }
      (mergedFilters as Record<K, Filters[K]>)[key] = value as Filters[K];
    });

    filters.value = mergedFilters;
    localStorage.setItem('Filters', JSON.stringify(filters.value));
  }

  function clearFilters() {
    filters.value = { ...DEFAULT_FILTERS };
    localStorage.removeItem('Filters');
  }

  function clearSpecificFilters(filterKeys: (keyof Filters)[]) {
    const updatedFilters: Filters = { ...filters.value };
    filterKeys.forEach(<K extends keyof Filters>(key: K) => {
      (updatedFilters as Record<K, Filters[K]>)[key] = DEFAULT_FILTERS[key] as Filters[K];
    });
    filters.value = updatedFilters;
    localStorage.setItem('Filters', JSON.stringify(filters.value));
  }

  return {
    filters,
    setFilters,
    clearFilters,
    clearSpecificFilters,
  };
});
